import { render, staticRenderFns } from "./TraderAvatarList.vue?vue&type=template&id=5757c06e&scoped=true&"
import script from "./TraderAvatarList.vue?vue&type=script&lang=js&"
export * from "./TraderAvatarList.vue?vue&type=script&lang=js&"
import style0 from "./TraderAvatarList.vue?vue&type=style&index=0&id=5757c06e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757c06e",
  null
  
)

export default component.exports